"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var assign = require("lodash/assign");
var get = require("lodash/get");
var omit = require("lodash/omit");
var React = require("react");
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var asRendition_1 = require("../asRendition");
var utils_1 = require("../utils");
var Txt_1 = require("./Txt");
var Base = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", ";\n  ", "\n  ", "\n\n  text-decoration: ", ";\n  cursor: ", ";\n  opacity: ", ";\n  display: inline-block;\n\n  &:active,\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  ", "\n  ", ";\n  ", "\n  ", "\n\n  text-decoration: ", ";\n  cursor: ", ";\n  opacity: ", ";\n  display: inline-block;\n\n  &:active,\n  &:hover {\n    color: ",
    ";\n  }\n"])), Txt_1.align, utils_1.monospace, Txt_1.caps, Txt_1.bold, function (props) { return props.decor || 'none'; }, function (props) { return (props.disabled ? 'not-allowed' : 'pointer'); }, function (props) { return (props.disabled ? 0.65 : 1); }, function (props) {
    return !props.disabled &&
        utils_1.darken(get(props.theme.colors, props.color) || props.color);
});
var Link = function (_a) {
    var is = _a.is, blank = _a.blank, children = _a.children, props = __rest(_a, ["is", "blank", "children"]);
    if (is) {
        Base = Base.withComponent(is);
    }
    if (props.disabled) {
        props = omit(props, 'href');
    }
    return (React.createElement(Base, __assign({}, props, { rel: blank ? 'noopener' : undefined, target: blank ? '_blank' : undefined }), children || props.href));
};
var setDefaultProps = recompose_1.withProps(function (props) {
    return assign({
        color: "primary.main",
    }, props);
});
exports.default = asRendition_1.default(Link, [setDefaultProps], ['color']);
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/rendition/dist/components/Link.js
// module id = 791
// module chunks = 2